<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px; max-width: 900px">
    <h3 style="text-align: center; font-size: 19px; padding-top: 20px">PRISM - Clinico</h3>
    <hr>
    <h4 style="font-size: 17px">Istruzioni: Lo spazio bianco rappresenta la Sua vita,
      il cerchio giallo rappresenta sè stesso e il cerchio rosso rappresenta la Sua malattia.
      Descriva quanto la Sua malattia influisca sulla Sua vita trascinando il cerchio rosso verso il cerchio giallo.
      <ul>
        <li>I due cerchi perfettamente sovrapposti, indicano il massimo impatto della malattia sulla Sua vita.</li>
        <li>Viceversa, quanto più il disco rosso viene posizionato lontano da quello giallo, tanto più significa che la malattia non ha impatto sulla Sua vita.</li>
      </ul>
    </h4>
    <br>
    <div class="container">
      <mat-card style="width: 650px; height: 350px; margin: auto" class="mat-elevation-z5">
        <canvas id="canvas" width="650" height="350" style="position: absolute; width: 600px; height: 300px; left: 0; top: 0;
          touch-action: none; user-select: none;"></canvas>
      </mat-card>
      <br><br>
      <div style="text-align: center; padding-top: 50px">
        <ng-container *ngIf="submitted">
          <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button class="mat-elevation-z4" mat-raised-button (click)="onSubmit()" color="primary">Invia</button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
